<div class="freigaben-page">
    <div class="list-title-row">
        <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="list-title">Meine Freigaben ({{ getSortedFreigaben().length || 0 }})</h3>
        <span class="spacer"></span>
        <button (click)="freigabeAnlegen()" color="accent" mat-icon-button>
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Freigaben durchsuchen...</mat-label>
            <input matInput placeholder="Datum, Betrieb oder wurde freigegeben für" [formControl]="searchControl" />
            <span matSuffix class="search-suffix">
                <button mat-icon-button aria-label="Clear" *ngIf="searchControl.value" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-icon class="search-suffix-icon">search</mat-icon>
            </span>
        </mat-form-field>
    </div>

    <div class="mobile-sort-row">
        <button mat-stroked-button [matMenuTriggerFor]="mobileSortMenu" class="mobile-sort-button">
            <mat-icon>sort</mat-icon>
            Sortieren: {{ getCurrentSortLabel() }}
        </button>
        <mat-menu #mobileSortMenu="matMenu" xPosition="before" yPosition="below">
            <button mat-menu-item (click)="setSortField('datum')">
                <mat-icon>event</mat-icon>
                <span>Nach Datum</span>
            </button>
            <button mat-menu-item (click)="setSortField('betrieb')">
                <mat-icon>business</mat-icon>
                <span>Nach Betrieb</span>
            </button>
            <button mat-menu-item (click)="setSortField('freigegebenFuer')">
                <mat-icon>assignment_turned_in</mat-icon>
                <span>Nach freigegeben für</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="setSortDirection('asc')">
                <mat-icon>arrow_upward</mat-icon>
                <span>Aufsteigend</span>
            </button>
            <button mat-menu-item (click)="setSortDirection('desc')">
                <mat-icon>arrow_downward</mat-icon>
                <span>Absteigend</span>
            </button>
        </mat-menu>
    </div>

    <ng-container *ngIf="isMobileScreen; else desktopFreigaben">
        <div class="mobile-cards" *ngIf="getSortedFreigaben()?.length; else noFreigaben">
            <div class="mobile-card" *ngFor="let f of getSortedFreigaben()">
                <div class="mobile-card__header">
                    <div class="mobile-card__title-wrap">
                        <div class="mobile-card__title">{{ getBetriebText(f) || '-' }}</div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="freigabeMenu" class="options-button">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #freigabeMenu="matMenu" xPosition="before" yPosition="below">
                        <button mat-menu-item (click)="deleteFreigabe(f)">
                            <mat-icon>delete</mat-icon>
                            <span>l&ouml;schen</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="mobile-card__grid">
                    <div class="mobile-card__item">
                        <span class="mobile-card__label">Datum</span>
                        <span class="mobile-card__value">{{ f.erstellt | date: "dd.MM.yyyy" }}</span>
                    </div>
                    <div class="mobile-card__item">
                        <span class="mobile-card__label">Betrieb</span>
                        <span class="mobile-card__value">{{ getBetriebText(f) }}</span>
                    </div>
                    <div class="mobile-card__item">
                        <span class="mobile-card__label">Freigegeben f&uuml;r</span>
                        <span class="mobile-card__value">{{ getFreigegebenFuerText(f) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #desktopFreigaben>
        <div class="list-wrapper" *ngIf="getSortedFreigaben()?.length; else noFreigaben">
            <div class="list-header">
                <button class="sort-header" type="button" (click)="setSort('datum')">
                    Datum
                    <mat-icon class="sort-icon" *ngIf="sortField === 'datum'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('betrieb')">
                    Betrieb
                    <mat-icon class="sort-icon" *ngIf="sortField === 'betrieb'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('freigegebenFuer')">
                    wurde freigegeben f&uuml;r
                    <mat-icon class="sort-icon" *ngIf="sortField === 'freigegebenFuer'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <span></span>
            </div>
            <ng-container *ngFor="let f of getSortedFreigaben(); let i = index">
                <div class="list-row">
                    <span class="row-cell">
                        <span class="mobile-field-label">Datum:</span>
                        <span class="mobile-field-value">{{ f.erstellt | date: "dd.MM.yyyy" }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Betrieb:</span>
                        <span class="mobile-field-value">{{ getBetriebText(f) }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Freigegeben f&uuml;r:</span>
                        <span class="mobile-field-value">{{ getFreigegebenFuerText(f) }}</span>
                    </span>
                    <span class="row-actions">
                        <button mat-icon-button [matMenuTriggerFor]="haendlerMenu" class="options-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #haendlerMenu="matMenu" xPosition="before" yPosition="below">
                            <button mat-menu-item (click)="deleteFreigabe(f)">
                                <mat-icon>delete</mat-icon>
                                <span>l&ouml;schen</span>
                            </button>
                        </mat-menu>
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-template>

    <h4 class="sub-title" *ngIf="geloeschteFreigaben?.length">Gel&ouml;schte Freigaben</h4>
    <ng-container *ngIf="isMobileScreen; else desktopDeletedFreigaben">
        <div class="mobile-cards" *ngIf="geloeschteFreigaben?.length">
            <div class="mobile-card" *ngFor="let f of getSortedGeloeschteFreigaben()">
                <div class="mobile-card__header">
                    <div class="mobile-card__title-wrap">
                        <div class="mobile-card__title">{{ getBetriebText(f) || '-' }}</div>
                    </div>
                </div>
                <div class="mobile-card__grid">
                    <div class="mobile-card__item">
                        <span class="mobile-card__label">Datum</span>
                        <span class="mobile-card__value">{{ f.erstellt | date: "dd.MM.yyyy" }}</span>
                    </div>
                    <div class="mobile-card__item">
                        <span class="mobile-card__label">Betrieb</span>
                        <span class="mobile-card__value">{{ getBetriebText(f) }}</span>
                    </div>
                    <div class="mobile-card__item">
                        <span class="mobile-card__label">Freigegeben f&uuml;r</span>
                        <span class="mobile-card__value">{{ getFreigegebenFuerText(f) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #desktopDeletedFreigaben>
        <div class="list-wrapper list-wrapper--deleted" *ngIf="geloeschteFreigaben?.length">
            <div class="list-header">
                <button class="sort-header" type="button" (click)="setSort('datum')">
                    Datum
                    <mat-icon class="sort-icon" *ngIf="sortField === 'datum'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('betrieb')">
                    Betrieb
                    <mat-icon class="sort-icon" *ngIf="sortField === 'betrieb'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('freigegebenFuer')">
                    wurde freigegeben f&uuml;r
                    <mat-icon class="sort-icon" *ngIf="sortField === 'freigegebenFuer'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <span></span>
            </div>
            <ng-container *ngFor="let f of getSortedGeloeschteFreigaben(); let i = index">
                <div class="list-row">
                    <span class="row-cell">
                        <span class="mobile-field-label">Datum:</span>
                        <span class="mobile-field-value">{{ f.erstellt | date: "dd.MM.yyyy" }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Betrieb:</span>
                        <span class="mobile-field-value">{{ getBetriebText(f) }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Freigegeben f&uuml;r:</span>
                        <span class="mobile-field-value">{{ getFreigegebenFuerText(f) }}</span>
                    </span>
                    <span class="row-actions"></span>
                </div>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #noFreigaben>
        <div class="empty-state">Keine Freigaben gefunden.</div>
    </ng-template>
</div>
